import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import EnrollmentLayout from '@views/Enrollment/layout/EnrollmentLayout';
const PublicOutlet = () => (_jsx(EnrollmentLayout, { children: _jsx(Outlet, {}) }));
export default PublicOutlet;
